// pages/Contact.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  MapPin, 
  Mail, 
  MessageCircle, 
  Clock, 
  ArrowRight, 
  Send,
  Phone
} from 'lucide-react';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    church: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thanks for reaching out! This is a design mockup, so no data was actually sent. Our team will get back to you within 24 hours.');
    setFormData({ name: '', email: '', church: '', message: '' });
  };

  return (
    <>
      {/* Hero Section - Navy Background */}
      <div className="page-hero">
        <div className="eyebrow light" style={{ display: 'inline-flex' }}>Contact</div>
        <h1>Let's talk about <span className="highlight">your church.</span></h1>
        <p>Questions about FaithConnect? Want to book a demo? We'd love to hear from you.</p>
      </div>

      {/* Contact Section - White Background */}
      <section>
        <div className="wrap contact-grid-modern">
          <div className="contact-info-modern animate-fadeInLeft">
            <h2>Get in touch</h2>
            <p className="lead">
              Whether you're ready to get started or just exploring options, our team is here to help you care for your congregation better.
            </p>

            <div className="contact-item-modern">
              <div className="contact-icon-modern">
                <MapPin size={20} />
              </div>
              <div>
                <h3>Office</h3>
                <p>Accra, Ghana</p>
              </div>
            </div>

            <div className="contact-item-modern">
              <div className="contact-icon-modern">
                <Mail size={20} />
              </div>
              <div>
                <h3>Email</h3>
                <p>hello@faithconnect.com</p>
              </div>
            </div>

            <div className="contact-item-modern">
              <div className="contact-icon-modern">
                <MessageCircle size={20} />
              </div>
              <div>
                <h3>WhatsApp</h3>
                <p>+233 XX XXX XXXX</p>
              </div>
            </div>

            <div className="contact-item-modern">
              <div className="contact-icon-modern">
                <Clock size={20} />
              </div>
              <div>
                <h3>Support hours</h3>
                <p>Monday - Friday, 8am - 6pm (GMT)</p>
              </div>
            </div>

            <div style={{ marginTop: 24 }}>
              <Link to="/faq" className="btn-ghost-dark">
                Visit our FAQ <ArrowRight size={18} />
              </Link>
            </div>
          </div>

          <div className="form-card-modern animate-fadeInRight">
            <form onSubmit={handleSubmit}>
              <div className="form-group-modern">
                <label htmlFor="name">Full name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group-modern">
                <label htmlFor="email">Email address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group-modern">
                <label htmlFor="church">Church name</label>
                <input
                  type="text"
                  id="church"
                  name="church"
                  value={formData.church}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group-modern">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Tell us about your church and what you're looking for..."
                ></textarea>
              </div>
              <button type="submit" className="btn-primary form-submit" style={{ width: '100%', justifyContent: 'center' }}>
                Send message <Send size={18} />
              </button>
              <div className="form-note" style={{ fontSize: '12px', color: 'var(--muted)', marginTop: '14px', textAlign: 'center' }}>
                <Clock size={14} style={{ display: 'inline', marginRight: '4px', verticalAlign: 'middle' }} />
                We'll respond within 24 hours.
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Final CTA - Navy Gradient */}
      <section className="final-cta">
        <div className="eyebrow light" style={{ position: 'relative', zIndex: 2 }}>Ready to get started?</div>
        <h2>Start your <span className="highlight">30-day free trial.</span></h2>
        <p>No credit card required. Full access to all features. Cancel anytime.</p>
        <Link to="/signup" className="btn-primary">
          Start free trial <ArrowRight size={18} />
        </Link>
      </section>
    </>
  );
}

export default Contact;